import { getFocusableElements } from '../utils/getFocusableElements';
import { isDesktop } from '../utils/isDesktop';
import { TOUJOU_FOCUSABLE_ELEMENTS } from '../utils/constants';

export function initTopbarTitle() {
  const minWidthDesktop = parseInt(getComputedStyle(document.querySelector('.wrap--navigation')).getPropertyValue('--main-nav-min-width-desktop'), 10) || 1024;

  const topbarSelector = '.top-bar';
  const topbarEl = document.querySelector(topbarSelector);
  if (!topbarEl) return;

  const topbarFocusableEls = getFocusableElements(topbarEl, `:is(${TOUJOU_FOCUSABLE_ELEMENTS}):not(.top-bar__title, .burger)`).all;

  const bodyEl = document.querySelector('body');

  const mutationObserver = new MutationObserver((mutations) => {
    if (isDesktop(minWidthDesktop)) return;

    mutations.forEach((mutation) => {
      if (mutation.target.hasAttribute('data-menuopen')) {
        topbarFocusableEls.forEach((el) => el.setAttribute('tabindex', '-1'));
      } else {
        topbarFocusableEls.forEach((el) => el.removeAttribute('tabindex'));
      }
    });
  });

  mutationObserver.observe(bodyEl, { attributes: true });
}
